import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
// wythStyles está obsoleto. TO-DO: actualizar a la nueva versión de MUI
import { withStyles } from "@material-ui/core";
import RegularButton from "../../components/CustomButtons/Button";
import Snackbars from "../../components/Snackbar/Snackbar.js";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { useForm } from "../../hooks/useForm";
import {
  deleteEmployee,
  createNewEmployee,
  editEmployee,
} from "../../redux/actions/employeesCatalog/employeesCatalogActions";
import { getUnitsConfigs } from "../../redux/actions/unitsSection/unitsAction";
import FormDirections from "./FormDirections";
import { searchPostalCodeAndColonyIds } from "./searchPostalCodeAndColonyIds";
import { initialValues, requiredValues } from "./initialValues";

const CustomFormControlLabel = withStyles({
  root: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    margin: 0,
    color: "grey",
  },
})(FormControlLabel);

const ALLOWED_UNIT_TYPES = ["MAYORISTA_P", "PORTATIL", "ESTACIONARIO", "MAYORISTA_E", "ESTACION"];

export const FormEmployeeEdit = (props) => {
  const [status, setStatus] = useState(true);
  const [snackBar, setSnackBar] = useState(false);
  const [filteredContracts, setFilteredContracts] = useState([]);
  const { stationsList: stations } = useSelector(({ companies }) => companies);
  const { handleClose } = props;
  const {
    employeeSelected,
    jobs,
    departments,
    contracts,
    addMode,
    deleteMode,
  } = useSelector((state) => state.employeesCatalog);
  const { stationsSelected, isLoadingComp } = useSelector((state) => state.search);
  const { unitsConfigArr } = useSelector((state) => state.unitsReducer);
  const filteredUnits = useMemo(() =>
    unitsConfigArr
      .filter((unit) => ALLOWED_UNIT_TYPES.includes(unit.unit_type))
      .sort((a, b) => String(a.number).localeCompare(String(b.number))),
    [unitsConfigArr]
  );
  const { token } = useSelector((state) => state.login);
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    fieldErrors,
    validate,
  } = useForm(initialValues, requiredValues);
  const {
    name,
    lastName,
    secondName,
    rfc,
    number,
    licenseNumber,
    consecutive,
    idStation,
    idDepartment,
    idJob,
    idContract,
    phone,
    email,
    idUnit,
    unitNumber,

    lat,
    lng,
    id,
    route,
    street_number,
    intNumber,
    postal_code,
    sublocality_level_1,
    locality,
    administrative_area_level_1,
    reference,
  } = inputValues;
  const dispatch = useDispatch();


  const handlePhoneNumber = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      handleNewValues({
        phone: value
      });
    }
  };
  const submit = async () => {
    if (deleteMode) {
      dispatch(deleteEmployee(employeeSelected.id));
      handleClose();
      return;
    }

    const { id_postal_code, id_colony } = await searchPostalCodeAndColonyIds(
      postal_code,
      sublocality_level_1,
      token
    );
    const newValues = {
      ...employeeSelected,
      name,
      lastName,
      secondName,
      rfc,
      number,
      licenseNumber: licenseNumber || null,
      consecutive: parseInt(consecutive),
      idStation,
      idDepartment,
      idJob,
      idContract: idContract || null,
      idUnit: idUnit || null,
      unitNumber: unitNumber || null,
      phone,
      email,
      status: status === 1 || status ? true : false,
      address: {
        id: id,
        street: route,
        ext_number: street_number,
        int_number: intNumber,
        postal_code: postal_code,
        id_postal_code,
        colony: sublocality_level_1,
        id_colony,
        municipality: locality,
        state: administrative_area_level_1,
        reference: reference,
        latitude: lat,
        longitude: lng,
      },
    };

    if (addMode) {
      dispatch(createNewEmployee(newValues, handleClose));
    } else {
      dispatch(editEmployee(employeeSelected.id, newValues, handleClose));
    }
  };

  const handleSubmit = () => validate([], submit);

  useEffect(() => {
    if (stationsSelected?.id) {
      handleNewValues({
        idStation: stationsSelected.id,
      });
    }
    if (employeeSelected) {
      handleNewValues({
        name: employeeSelected.name ? employeeSelected.name : "",
        lastName: employeeSelected.lastName ? employeeSelected.lastName : "",
        secondName: employeeSelected.secondName
          ? employeeSelected.secondName
          : "",
        rfc: employeeSelected.rfc ? employeeSelected.rfc : "",
        number: employeeSelected.number ? employeeSelected.number : "",
        consecutive: employeeSelected.consecutive
          ? employeeSelected.consecutive
          : "",
        idStation: employeeSelected.idStation ? employeeSelected.idStation : "",
        idDepartment: employeeSelected.idDepartment
          ? employeeSelected.idDepartment
          : "",
        idJob: employeeSelected.idJob ? employeeSelected.idJob : "",
        idContract: employeeSelected.idContract
          ? employeeSelected.idContract
          : "",
        phone: employeeSelected.phone ? employeeSelected.phone : "",
        email: employeeSelected.email ? employeeSelected.email : "",
        idUnit: employeeSelected.idUnit ? employeeSelected.idUnit : "",
        unitNumber: employeeSelected.unitNumber ? employeeSelected.unitNumber : "",
        licenseNumber: employeeSelected.licenseNumber ? employeeSelected.licenseNumber : "",
      });
      setStatus(
        employeeSelected.status === 1 || employeeSelected.status ? true : false
      );
    }
    // eslint-disable-next-line
  }, [employeeSelected, stationsSelected]);

  useEffect(() => {
    setFilteredContracts(
      contracts.filter((contract) => contract.idStation === idStation)
    );
    if (idStation) dispatch(getUnitsConfigs(idStation));
    // eslint-disable-next-line
  }, [idStation]);

  return (
    <>
      <Typography component="h2">
        {addMode
          ? "Agregar nuevo empleado"
          : deleteMode
            ? "¿Estas seguro de eliminar a este empleado?"
            : "Modificar empleado"}
      </Typography>
      <FormControl
        fullWidth
        style={{ display: "flex", gap: 10, marginTop: 20 }}
        onSubmit={handleSubmit}
      >
        <TextField
          type="text"
          label="Nombre *"
          name="name"
          value={name}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={!!fieldErrors.name}
          helperText={fieldErrors.name}
        />
        <TextField
          type="text"
          label="Apellido Paterno *"
          name="lastName"
          value={lastName}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={!!fieldErrors.lastName}
          helperText={fieldErrors.lastName}
        />
        <TextField
          type="text"
          label="Apellido Materno *"
          name="secondName"
          value={secondName}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
        />
        <TextField
          type="text"
          label="RFC *"
          name="rfc"
          value={rfc}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={!!fieldErrors.rfc}
          helperText={fieldErrors.rfc}
        />
        <TextField
          type="text"
          label="No. Empleado *"
          name="number"
          value={number}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={!!fieldErrors.number}
          helperText={fieldErrors.number}
        />
        <TextField
          type="text"
          label="Licencia"
          name="licenseNumber"
          value={licenseNumber}
          disabled={deleteMode}
          onChange={(e) => {
            const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
            handleNewValues({ licenseNumber: val });
          }}
          variant="outlined"
        />
        <TextField
          type="number"
          label="Consecutivo *"
          name="consecutive"
          value={consecutive}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={!!fieldErrors.consecutive}
          helperText={fieldErrors.consecutive}
        />
        <FormControl fullWidth variant="outlined"
          error={!!fieldErrors.idStation}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            Planta *
          </InputLabel>
          <Select
            name="idStation"
            value={idStation}
            onChange={(e) => handleNewValues({ idStation: e.target.value, idUnit: "", unitNumber: "", idContract: "" })}
            label="Planta *"
            disabled={
              deleteMode ||
              (stationsSelected?.id && !employeeSelected?.idStation)
            }
          >
            {stations.map((station) => (
              <MenuItem value={station.value} key={station.value}>{station.label}</MenuItem>
            ))}
          </Select>
          {!!fieldErrors.idStation && <FormHelperText>{fieldErrors.idStation}</FormHelperText>}
        </FormControl>
        <FormControl fullWidth variant="outlined"
          error={!!fieldErrors.idDepartment}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            Departamento *
          </InputLabel>
          <Select
            name="idDepartment"
            value={idDepartment}
            onChange={(e) => handleInputOnChange(e)}
            label="Departamento *"
            disabled={deleteMode}
          >
            {departments.map((department) => (
              <MenuItem value={department.value} key={department.value}>{department.label}</MenuItem>
            ))}
          </Select>
          {!!fieldErrors.idDepartment && <FormHelperText>{fieldErrors.idDepartment}</FormHelperText>}
        </FormControl>
        <FormControl fullWidth variant="outlined"
          error={!!fieldErrors.idJob}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            Posición *
          </InputLabel>
          <Select
            name="idJob"
            value={idJob}
            onChange={(e) => handleInputOnChange(e)}
            label="Posición *"
            disabled={deleteMode}
            options={jobs}
          >
            {jobs.map((job) => (
              <MenuItem value={job.value} key={job.value}>{job.label}</MenuItem>
            ))}
          </Select>
          {!!fieldErrors.idJob && <FormHelperText>{fieldErrors.idJob}</FormHelperText>}
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">
            Contrato
          </InputLabel>
          <Select
            name="idContract"
            value={idContract}
            onChange={(e) => handleInputOnChange(e)}
            label="Contrato *"
            disabled={deleteMode}
            options={filteredContracts}
          >
            {filteredContracts.map((contract) => (
              <MenuItem value={contract.value} key={contract.value}>{contract.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Telefono *"
          name="phone"
          value={phone}
          disabled={deleteMode}
          onChange={handlePhoneNumber}
          variant="outlined"
          error={!!fieldErrors.phone}
          helperText={fieldErrors.phone}
          inputProps={{
            right: '1',
          }}
        />
        <TextField
          type="email"
          label="Email *"
          name="email"
          value={email}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={!!fieldErrors.email}
          helperText={fieldErrors.email}
        />
        <CustomFormControlLabel
          control={
            <Checkbox
              name="status"
              onChange={() => setStatus(!status)}
              checked={status}
              disabled={deleteMode}
              color="primary"
            />
          }
          labelPlacement="start"
          label="Estatus"
        />
        <AutocompleteComponent
          name="idUnit"
          value={filteredUnits.find((u) => u.value === idUnit) || null}
          options={filteredUnits}
          label="Unidad"
          disabled={deleteMode}
          customAction={(v) => handleNewValues({ idUnit: v?.value ?? "", unitNumber: v?.number ?? "" })}
        />
        <FormDirections
          values={inputValues}
          errors={fieldErrors}
          onChange={handleInputOnChange}
          setValues={handleNewValues}
          personSelected={employeeSelected}
          deleteMode={deleteMode}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 30,
          }}
        >
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleClose}
            disabled={isLoadingComp?.loadingEmployeesCrud}
          >
            Cancelar
          </RegularButton>
          <RegularButton
            variant="contained"
            color="info"
            onClick={handleSubmit}
            loading={isLoadingComp?.loadingEmployeesCrud}
          >
            {addMode ? "Agregar" : deleteMode ? "Eliminar" : "Guardar"}
          </RegularButton>
        </Box>
      </FormControl>
      <Snackbars
        place="tr"
        color="danger"
        message="Campos con * son requeridos"
        open={snackBar}
        closeNotification={() => setSnackBar(false)}
        close
      />
    </>
  );
};
